import PropTypes from "prop-types";
import { viewPhoneFromFlat, viewPhoneShape } from "@shared/models/Communications/viewPhone";
import DncFlag from "@shared/Sms/DncFlag";
import IconDropdown from "./Interactions/IconDropdown";
import StatusOption from "./Interactions/PhoneStatusOption";
import { PopoverItem } from "@shared/v2/Popover";

const callablePhone = viewPhoneFromFlat({});
const callUnsubscribedPhone = viewPhoneFromFlat({ call_soft_unsubscribed: true });

const smsTextablePhone = viewPhoneFromFlat({ sms_textable: true, value: "123" });
const smsNotTextablePhone = viewPhoneFromFlat({ sms_textable: false });
const smsUnsubscribedPhone = viewPhoneFromFlat({ sms_soft_unsubscribed: true });
const smsStatusLabels = {
  valid: "Can Be Texted",
  voiceOnly: "Cannot Be Texted",
  invalid: "Invalid",
  unsubscribed: "Opted Out",
};

const PhoneValue = ({ phone, hideCallStatus, isDnc, showPrimaryStatus, onChange, hideDropdown }) => {
  const { formattedNumber, callIcon, smsIcon, mobileCallIcon, isMobile, isPrimary } = phone;
  const usedIcon = isMobile ? mobileCallIcon : callIcon;

  const callIconKey = phone.isMobile ? "mobileCallIcon" : "callIcon";
  const callOptions = [
    {
      status: "valid",
      icon: callablePhone[callIconKey].icon({ size: "l" }),
      onClick: () => onChange("valid", "call"),
    },
    {
      status: "unsubscribed",
      icon: callUnsubscribedPhone[callIconKey].icon({ size: "l" }),
      onClick: () => onChange("unsubscribed", "call"),
    },
  ].map(({ onClick, ...x }) => (
    <PopoverItem onClick={onClick} className="tw-w-[145px]">
      <StatusOption {...x} />
    </PopoverItem>
  ));

  const smsOptions = [
    {
      status: "valid",
      icon: smsTextablePhone.smsIcon.icon({ size: "xl" }),
      onClick: () => onChange("valid", "sms"),
    },
    {
      status: "voiceOnly",
      icon: smsNotTextablePhone.smsIcon.icon({ size: "xl" }),
      onClick: () => onChange("voiceOnly", "sms"),
    },
    {
      status: "unsubscribed",
      icon: smsUnsubscribedPhone.smsIcon.icon({ size: "xl" }),
      onClick: () => onChange("unsubscribed", "sms"),
    },
  ].map(({ onClick, ...x }) => (
    <PopoverItem onClick={onClick}>
      <StatusOption {...x} statusTexts={smsStatusLabels} />
    </PopoverItem>
  ));

  const currentCallIcon = usedIcon.icon({ size: "xl" });
  const currentSmsIcon = smsIcon.icon({ size: "xl" });

  return (
    <div className="tw-w-full">
      <div className="tw-flex tw-flex-row tw-items-center tw-space-x-12px tw-w-full tw-relative">
        {!hideCallStatus && (
          <div className="tw-flex tw-flex-row tw-items-center">
            <IconDropdown icon={currentCallIcon} tooltip={usedIcon.tooltip} editable={phone.callEditable}>
              {callOptions}
            </IconDropdown>
          </div>
        )}
        <div className="tw-flex tw-flex-row tw-items-center">
          <IconDropdown
            hideDropdown={hideDropdown}
            icon={currentSmsIcon}
            tooltip={smsIcon.tooltip}
            editable={phone.smsEditable}
          >
            {smsOptions}
          </IconDropdown>
        </div>
        <span>
          {formattedNumber} {showPrimaryStatus && isPrimary && "(*)"}
        </span>
        <DncFlag show={isDnc} />
      </div>
    </div>
  );
};

PhoneValue.propTypes = {
  hideCallStatus: PropTypes.bool,
  hideDropdown: PropTypes.bool,
  isDnc: PropTypes.bool,
  phone: PropTypes.shape(viewPhoneShape),
  showPrimaryStatus: PropTypes.bool,
};

PhoneValue.defaultProps = {
  hideCallStatus: false,
  hideDropdown: false,
  isDnc: false,
  phone: {},
  showPrimaryStatus: false,
};

export default PhoneValue;
